<template>
    <!-- 在根元素上绑定点击事件 -->
    <div class="mileage_item_info" :class="{ 'selected': selected }" @click="handleClick">
        <div style="padding:16px;">
            <div style="display: flex;align-items: center;">
                <div style="background: #2A7AFF;width: 6px;height: 6px;border-radius: 50%;"></div>
                <div style="font-size: 12px;color: #0E193B;margin-left: 12px;">{{$t('driver.统计时间')}}：{{time}}</div>
            </div>
            <div style="display: flex;margin-top: 14px;">
                <div style="display: flex;flex-direction: column;flex: 1;text-align: center;">
                    <div style="font-size: 12px;color: #0E193B;">{{$t('driver.里程')}}</div>
                    <div style="font-size: 14px;color: #0E193B;margin-top: 4px;">{{mileage}}</div>
                </div>
                <div style="display: flex;flex-direction: column;flex: 1;text-align: center;">
                    <div style="font-size: 12px;color: #0E193B;">{{$t('driver.驾驶评分')}}</div>
                    <div style="font-size: 14px;color: #0E193B;margin-top: 4px;">{{score}}</div>
                </div>
            </div>
        </div>
        <div style="height: 1px;background: #D9E4F8;width: 100%;"></div>
    </div>
</template>
<script >
export default{
    props:{
        score:{
            type:Number,
            default:0
        },  
        mileage:{
            type:Number,
            default:0
        },  
        time:{
            type:String,
            default:''
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
	methods: {
	  handleClick() {
		  // 传递组件实际拥有的props数据
		  this.$emit('click', {
              score: this.score,
              mileage: this.mileage,
              time: this.time
          });
	  }
	}
}
</script>
<style scoped>
.mileage_item_info {
    background: #FFF;
    cursor: pointer;
    transition: background-color 0.2s; /* 增加过渡效果 */
}

.mileage_item_info:hover {
    background: #E8F0FF;
}

.mileage_item_info.selected {
    background: #E8F0FF;
    border-left: 3px solid #2A7AFF;
}
</style>
